import { graphql } from 'gatsby'
import React from 'react'

import { PortfolioQueryQuery } from '../../types/graphql-types'
import EnhancedMeta from '../components/meta/enhanced-meta'
import Layout from '../components/layout/layout'
import Portfolio from '../components/portfolio'
import Appointment from '../components/appointment'

interface Props {
  data: PortfolioQueryQuery
  location: Location
}

const Index: React.FC<Props> = ({ data, location }: Props) => {
  const meta = data.site?.meta

  return (
    <Layout location={location}>
      <EnhancedMeta
        title="Portfolio | Before & After Results | Ada Aesthetics Cheshunt"
        description="View our stunning before and after results from Botox, lip fillers, dermal fillers, and beauty treatments at Ada Aesthetics in Cheshunt. Real client transformations."
        keywords="Ada Aesthetics portfolio, before and after, treatment results Cheshunt, aesthetic treatment gallery"
        url="https://adaaesthetics.uk/portfolio"
        site={meta}
      />
      <Portfolio />
      <Appointment />
    </Layout>
  )
}

export default Index

export const pageQuery = graphql`
  query PortfolioQuery {
    site {
      meta: siteMetadata {
        title
        description
        siteUrl
        author
      }
    }
  }
`
